$(() => {
    const axios = require('axios/dist/axios.min');

    if (!$('#documents_edit_page').length && !$('#documents_detail_page').length) {
        return;
    }

   /**
     * アップロード済みワイルの削除
     */
    $('.file-delete').on('click', function(e) {
        e.preventDefault();
        if (!confirm('このファイルを削除してよろしいですか？')) {
            return;
        }
        $this = $(this);
        let dataObj = {};
        dataObj.type = $(this).data('type');
        dataObj.corporate_id = $(this).data('corporate_id');
        let role = $(this).data('role');
        axios.post('/' + role + '/corporate/documents/delete_file', dataObj)
        .then(function (response) {
            alert(response.data.message);
            if (response.data.status) {
                $this.parent().remove();
            }
        });

        return false;
    });
});
